<template>
  <div :class="['page-dataIndex', isFullscreen ? 'page-fullscreen': '']" id="pageDataIndex" v-loading="loading" element-loading-background="rgba(2,17,38,.1)">
    <ec-screenfull @handleFullscreen="handleFullscreen" target="pageDataIndex" class="full-screen" />
    <div class="dataIndex__main" id="dataIndexMain">
      <div class="dataIndex__top">
        <div class="dataIndex__title">数据中心</div>
      </div>
      <div class="dataIndex__content">
        <div class="dataIndex__col dataIndex__col--1">
          <ec-block
            class="dataIndex__block dataIndex__block--1"
            :title="trade.title"
            :tagTxt="trade.tagTxt">
            <ec-list
              :data="tradeNumber">
            </ec-list>
          </ec-block>
          <ec-block
            class="dataIndex__block  dataIndex__block--1"
            :title="business.title"
            :tagTxt="business.tagTxt">
            <div class="ec-chart--wrap">
              <div class="ec-chart ec-chart--business" id="ecChartBusiness">
              </div>
            </div>
          </ec-block>
          <ec-block
            class="dataIndex__block dataIndex__block--customer"
            :title="customer.title"
            :tagTxt="customer.tagTxt">
            <div class="ec-chart--wrap">
              <div class="ec-chart ec-chart--customer" id="ecChartCustomer">
              </div>
            </div>
            <div class="customer-sex">
                <div class="customer-sex__item" v-for="(item, index) in customerSex" :key="index">
                  <div class="customer-sex__icon" :class="item.name"></div>
                  <div class="customer-sex__txt">{{item.value}}%</div>
                </div>
            </div>
          </ec-block>
        </div>
        <div class="dataIndex__col dataIndex__col--2">
          <div class="center">
            <ec-box
               class="dataIndex__box"
              :data="centralData">
            </ec-box>
            <ec-map
              class="dataIndex__map"
              :data="mapData">
            </ec-map>
          </div>
          <ec-block
            class="dataIndex__block dataIndex__block--transactionFlow"
            :title="transactionFlow.title"
            :tagTxt="transactionFlow.tagTxt">
            <div class="ec-chart--wrap">
              <div class="ec-chart ec-chart--transactionFlow" id="ecChartTransactionFlow">
              </div>
            </div>
          </ec-block>
        </div>
        <div class="dataIndex__col dataIndex__col--3">
          <ec-block
            class="dataIndex__block"
            :title="powerRanking.title"
            :tagTxt="powerRanking.tagTxt">
            <div class="ec-chart--wrap">
              <div class="ec-chart ec-chart--powerRanking" id="ecChartPowerRanking">
              </div>
            </div>
          </ec-block>
          <ec-block
            cls="module ec-block--equipmentFailureRate"
            :title="equipmentFailureRate.title"
            :tagTxt="equipmentFailureRate.tagTxt">
            <div class="ec-chart--wrap">
              <div class="ec-chart ec-chart--equipmentFailureRate" id="ecChartEquipmentFailureRate">
              </div>
            </div>
          </ec-block>
          <ec-block
            cls="module ec-block--equipmentFailureStatus"
            :title="equipmentFailureStatus.title"
            :tagTxt="equipmentFailureStatus.tagTxt">
            <div class="ec-chart--wrap">
              <div class="ec-chart ec-chart--equipmentFailureStatus" id="ecChartEquipmentFailureStatus">
              </div>
            </div>
          </ec-block>
          <ec-block
            cls="module ec-block--equipmentType"
            :title="equipmentType.title"
            :tagTxt="equipmentType.tagTxt">
            <div class="ec-chart--wrap">
              <div class="ec-chart ec-chart--equipmentType" id="ecChartEquipmentType">
              </div>
            </div>
          </ec-block>
        </div>
      </div>
    </div>
    <ec-socket 
      @handleSocket="handleSocket"
      />
  </div>
</template>
<script>
var echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
require('echarts/lib/chart/pie');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/legend');
import EcBlock from './components/EcBlock'
import EcList from './components/EcList'
import EcBox from './components/EcBox'
import EcMap from './components/EcMap'
import EcSocket from './components/EcSocket'
import getEchartData from './data/index'
export default {
  name: 'DataIndex',
  data () {
    return {
      trade: {
        title: '交易笔数排名',
        tagTxt: '今日'
      },
      tradeNumber: [],
      business: {
        title: '各业务交易分析',
        tagTxt: '今日'
      },
      customer: {
        title: '客户行为分析',
        tagTxt: '今日'
      },
      customerSex: [],
      powerRanking: {
        title: '开机率排名',
        tagTxt: '今日'
      },
      equipmentFailureRate: {
        title: '设备故障率',
        tagTxt: '今日'
      },
      equipmentFailureStatus: {
        title: '设备故障情况分析',
        tagTxt: '今日'
      },
      equipmentType: {
        title: '设备类型比例',
        tagTxt: '今日'
      },
      centralData: [],
      mapData: [],
      transactionFlow: {
        title: '交易流水',
        tagTxt: '近15日'  
      },
      echarts: {
        business: null,
        customer: null,
        powerRanking: null,
        equipmentFailureRate: null,
        equipmentFailureStatus: null,
        equipmentType: null,
        transactionFlow: null
      },
      echartData: {},
      isFullscreen: false,
      loading: true
    }
  },
  components: {
    EcBlock,
    EcList,
    EcBox,
    EcMap,
    EcSocket
  },
  watch: {
    '$store.state.isCollapse' () {
      this.resizeEcchart('collapse')
    }
  },
  activated() {
    this.render()
  },
  deactivated() {
    // 移除任何你不想保留的数据
    Object.keys(this.echarts).forEach((key) => {
      this.echarts[key] && this.echarts[key].clear()
      this.echarts[key] = null
    })
  },
  methods: {
    getEcchartOption (arr = [], key = 'date') {
      let result = {
        legendData: [],
        seriesData: arr
      }
      arr.forEach(ele => {
        result.legendData.push(ele[key] && ele[key])
      });
      return result
    },
    async getData () {
      const _this = this
      const { data } = await _this.Api.queryDataIndex()
      this.loading = false
      this.echartData = data
      this.render();
    },
    render () {
      var oPageDataIndex = document.getElementById('pageDataIndex')
      if (!oPageDataIndex) {
        return ;
      }
      // 交易笔数排名
      this.tradeNumber = this.echartData["tradeNumber"]
      // 实时数据
      this.centralData = this.echartData["centralData"]
      // 地图
      this.mapData = this.echartData["mapData"]
      // 客户性别比例
      this.customerSex = this.echartData["customerSex"]

      Object.keys(this.echarts).forEach((key) => {
        let domKey = `${key.charAt(0).toUpperCase()}${key.slice(1)}`
        let oEchartItem = document.getElementById('ecChart' + domKey)
        let mapOption = {
          "business": 'currentHour',
          "transactionFlow": "date",
        }
        let echartOptionId = mapOption[key] || 'name'
        let dataEchartItem = this.getEcchartOption(this.echartData[key], echartOptionId)
        
        this.echarts[key] = echarts.init(oEchartItem)
        let option = getEchartData[key](dataEchartItem)
        this.echarts[key].setOption(option)
        if (['customer', 'powerRanking', 'transactionFlow'].includes(key)) {
          this.echarts[key].option = option
        }
      })
    },
    resizeEcchart (type) {
      let isChrome = navigator.userAgent.indexOf('AppleWebKit') > -1
      let timer = setTimeout(() => {
        Object.keys(this.echarts).forEach((key) => {
          if (!this.echarts[key]) return
          if ((['customer', 'powerRanking', 'transactionFlow'].includes(key) && type == 'collapse') 
              || ( ['customer'].includes(key) && isChrome && type == "fullScreen")) {
            this.echarts[key].clear()
            let option = this.echarts[key].option
            this.echarts[key].setOption( option, true )
            if (['customer'].includes(key) && isChrome && type == "fullScreen") {
              this.echarts[key].resize()
            }
          } else {
            this.echarts[key] && this.echarts[key].resize()
          }
        })
        clearTimeout(timer)
      })
    },
    handleFullscreen (val) {
      this.isFullscreen = val
      this.resizeEcchart('fullScreen')
      this.calcMapMargin()
    },
    handleSocket (data) {
      this.echartData = data
      this.render()
    },
    getStyle (obj, attr) {
      if (obj.currentStyle) {
        return obj.currentStyle[attr]
      } else {
        return getComputedStyle(obj, null)[attr]
      }
    },
    calcMapMargin () { // 调整map的高度
      this.$nextTick(() => {
        let oCenter = document.querySelector('.center')
        let oDataIndexBox = document.querySelector('.ec-box')
        let oCenterHeight = parseInt(this.getStyle(oCenter, 'height'))
        let oCenterPadding = parseInt(this.getStyle(oCenter, 'paddingTop')) * 2
        let oDataIndexBoxHeight = 81 +  parseInt(this.getStyle(oDataIndexBox, 'marginTop'))
        let dis = oCenterHeight - oCenterPadding - oDataIndexBoxHeight
        let oMap = document.querySelector('.dataIndex__map')
        // 329: 地图图片的高度
        if ( dis < 329) {
          oMap.style.marginTop = dis - 329 + 'px'
        } else {
          oMap.style.marginTop = (dis - 329) / 2 + 'px'
        }
      })
    }
  },
  mounted () {
    this.getData()
    this.calcMapMargin ()
    let timer = setTimeout(() => {
      this.loading = false
      clearTimeout(timer)
    }, 1000)
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/theme/variables.scss";
$colMargin: 4px;
$dataIndexPadding: 4px;
$fullScreenColMargin: 10px;
$fullScreenDataIndexPadding: 10px;
.page-dataIndex {
  background: $dataIndexBg;
  width: 100%;
  position: relative;
  padding: 10px $dataIndexPadding $dataIndexPadding;
  .full-screen {
    position: absolute;
    top: 10px;
    right: $dataIndexPadding;
    z-index: 1;
  }
}
.dataIndex {
  &__main {
    .page-fullscreen & {
      -webkit-animation:  fadeOut 20s infinite;
      animation:  fadeOut 20s infinite;
      position: relative;
    }
  }
  &__top {
    width: auto;
    height: 52px;
    background: url(../../assets/img/dataIndex-title.png) center bottom no-repeat;
    background-size: contain;
  }
  &__title {
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    text-align: center;
  }
  &__content {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    min-height: calc(100vh - 180px);
    margin-top: -16px;
  }
  &__box {
    margin-top: 16px;
  }
  &__map {
    margin-top: -43px;
  }
}
.dataIndex__col {
  &.dataIndex__col--1,
  &.dataIndex__col--3 {
    width: 25%;
  }
  &.dataIndex__col--2 {
    padding: 0 $colMargin;
  }
  &.dataIndex__col--2 {
    flex-basis: auto;
    flex-grow: 1;
  }
}
.dataIndex {
  &__block {
    margin-bottom: $colMargin;
    min-height: 200px;
    .dataIndex__col--1 &,
    .dataIndex__col--2 & {
      height: calc(100% / 3 - 4px);
    }
    .dataIndex__col--3 &:first-child {
      height: calc(100% / 3 - 4px);
    }
    &.dataIndex__block--customer {
      position: relative;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.dataIndex__col--3 .ec-block.module {
  height: calc(100% * 2  / 9 - 4px / 3);
  min-height: calc(404px / 3);
}
.ec-chart--wrap {
  position: absolute;
  width: 100%;
}
.ec-chart--wrap,
.ec-chart {
  display: block;
  height: 100%; 
}
.center {
  height: calc(100% - calc(100% / 3 - 4px) - 8px);
  margin-bottom: 4px;
  min-height: 404px;
  padding: 10px;
  text-align: center;
}
.customer-sex {
    position: absolute;
    width: 40px;
    height: 50px;
    top: 50%;
    left: 50%;
    margin-left: -20px;
    margin-top: -22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 10px;
    text-align: center;
    &__item:first-child {
      margin-right: 4px;
    }
    .male{
      font-size: 12px;
      text-align: center;
      line-height: 16px;
    }
    .female{
      font-size: 12px;
      text-align: center;
      line-height: 16px;
    }
    &__icon.male {
      width: 18px;
      height: 45px;
      margin-bottom: -10px;
      transform: scale(.5);
      background: url(../../assets/img/dataIndex-male.png) left center no-repeat
    }
    &__icon.female {
      width: 19px;
      height: 44px;
      margin-bottom: -10px;
      transform: scale(.5);
      background: url(../../assets/img/dataIndex-female.png) center no-repeat
    }
}
// 全屏样式
.page-fullscreen.page-dataIndex {
  padding: $fullScreenDataIndexPadding;
  .center {
    height: calc(100% - calc(100% / 3 - 10px) - 20px);
    margin-bottom: 10px;
    min-height: 0;
  }
  .dataIndex {
    &__col.dataIndex__col--2 {
      padding: 0 $fullScreenColMargin;
    }
    &__top {
      height: 90px;
      line-height: 90px;
    }
    &__content {
      height: calc(100vh - 100px);
    }
    &__block {
      min-height: 0;
      margin-bottom: $fullScreenColMargin;
    }
    &__map {
      margin-top: -45px;
    }
  }
  .dataIndex__col--1,
  .dataIndex__col--2 {
    .dataIndex__block {
      height: calc(100% / 3 - 10px);
    }
  }
  .dataIndex__col--3 {
    .dataIndex__block:first-child {
      height: calc(100% / 3 - 10px);
    }
    .ec-block.module {
      height: calc(100% * 2  / 9 - 10px / 3);
      min-height: 0;
    }
    .ec-block.module.ec-block--equipmentType {
      min-height: 0px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/dataIndex/index.vue